export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNav.vue?vue&type=template&id=2883c6a6"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNav.vue?vue&type=template&id=2883c6a6
// module id = null
// module chunks = 